module.exports = {"450502001":"中街街道","450502002":"东街街道","450502003":"西街街道","450502004":"海角街道","450502005":"地角街道","450502006":"高德街道","450502007":"驿马街道","450502100":"涠洲镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450502.json
// module id = 2117
// module chunks = 0